export interface ErrorCode {
  code: number;
  msg: string;
}

/**
 * 根据错误码翻译错误信息
 * @param code
 * @param errorMsg
 * @returns
 */
export function getErrorMessage (code: number, errorMsg?: string): string {
  const errorInfo = ERROR_CODE.find((item: ErrorCode) => item.code === code)
  return errorInfo ? errorInfo.msg : errorMsg || 'Server error'
}

// 错误编码
export const ERROR_CODE = [
  {
    code: 2,
    msg: '手动取消待执行任务.',
  },
  {
    code: 312014,
    msg: '设备升级中，请勿重复操作.',
  },
  {
    code: 312015,
    msg: '机场：{dock_org_name} 业务繁忙无法进行设备升级，请等待机场处于空闲中后再试.',
  },
  {
    code: 312016,
    msg: '升级失败，机场和飞行器图传链路异常，请重启机场和飞行器后重试.',
  },
  {
    code: 312022,
    msg: '飞行器开机失败或未连接，请检查飞行器是否在舱内，是否安装电池，机场和飞行器是否已对频.',
  },
  {
    code: 312023,
    msg: '推杆闭合失败无法升级飞行器，请检查急停按钮是否被按下，推杆是否有异物卡住.',
  },
  {
    code: 312027,
    msg: '升级失败，机场未检测到飞行器.',
  },
  {
    code: 312028,
    msg: '升级失败，设备升级过程中设备被重启.',
  },
  {
    code: 312029,
    msg: '设备重启中无法进行设备升级，请等待设备重启完成后重试.',
  },
  {
    code: 312030,
    msg: '升级失败，飞行器增强图传开启后无法升级，请关闭飞行器增强图传后重试.',
  },
  {
    code: 312704,
    msg: '设备电量过低, 请充电至20%以上后重试.',
  },
  {
    code: 314000,
    msg: '设备当前无法支持该操作，建议检查设备当前工作状态.',
  },
  {
    code: 314001,
    msg: '飞行任务下发失败,请稍后重试.',
  },
  {
    code: 314002,
    msg: '飞行任务下发失败,请稍后重试.',
  },
  {
    code: 314003,
    msg: '航线文件格式不兼容，请检查航线文件是否正确.',
  },
  {
    code: 314004,
    msg: 'Failed to send flight route task from cloud',
  },
  {
    code: 314005,
    msg: '飞行任务下发失败，请稍后重试或重启机场后重试.',
  },
  {
    code: 314006,
    msg: '飞行器初始化失败，请重启机场后重试.',
  },
  {
    code: 314007,
    msg: '机场传输航线至飞行器失败，请重启机场后重试.',
  },
  {
    code: 314008,
    msg: '飞行器起飞前准备超时，请重启机场后重试.',
  },
  {
    code: 314009,
    msg: '飞行器初始化失败，请重启机场后重试.',
  },
  {
    code: 314010,
    msg: '航线执行失败，请重启机场后重试.',
  },
  {
    code: 314011,
    msg: '机场系统异常，无法获取飞行任务执行结果.',
  },
  {
    code: 314012,
    msg: '飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试.',
  },
  {
    code: 314013,
    msg: '飞行任务下发失败，机场无法获取到本次飞行任务的航线，无法执行飞行任务，请稍后重试.',
  },
  {
    code: 314014,
    msg: '机场系统异常，飞行任务执行失败，请稍后重试.',
  },
  {
    code: 314015,
    msg: '机场传输精准复拍航线至飞行器失败，无法执行飞行任务，请稍后重试或重启机场后重试.',
  },
  {
    code: 314016,
    msg: '航线文件解析失败，无法执行飞行任务，请检查航线文件.',
  },
  {
    code: 314017,
    msg: '航线文件解析失败，请检查航线后再试.',
  },
  {
    code: 314018,
    msg: '飞行器 RTK 定位异常，无法执行飞行任务，请稍后重试或重启机场后重试.',
  },
  {
    code: 314019,
    msg: '飞行器 RTK 收敛失败，无法执行飞行任务，请稍后重试或重启机场后重试.',
  },
  {
    code: 314020,
    msg: '飞行器不在停机坪正中间或飞行器朝向不正确，无法执行飞行任务，请检查飞行器位置和朝向.',
  },
  {
    code: 314021,
    msg: '飞行器 RTK 定位异常，无法执行飞行任务，请稍后重试或重启机场后重试.',
  },
  {
    code: 314024,
    msg: '进离场航线下发失败，请稍后重试或重启机场后重试.',
  },
  {
    code: 314025,
    msg: 'RTK收敛超时，用户手动取消任务.',
  },
  {
    code: 314200,
    msg: '任务失败，由于机场网络断开，飞行器已自动返航，请确保机场已连接网络后再试.',
  },
  {
    code: 315000,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315001,
    msg: '机场通信异常，请远程开启飞机并等待 1min 后，再次下发任务重试.',
  },
  {
    code: 315002,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315003,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315004,
    msg: '任务失败，请等待两个机场都空闲后，再次下发任务重试.',
  },
  {
    code: 315005,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315006,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315007,
    msg: '机场通信异常，请将机场升级到最新版本或重启机场后重试.',
  },
  {
    code: 315008,
    msg: '降落机场和起飞机场标定信息不一致，请确认两个机场均链路通畅且使用了相同的网络信息标定.',
  },
  {
    code: 315009,
    msg: '机场通信异常，请重启机场后重试.',
  },
  {
    code: 315010,
    msg: '无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315011,
    msg: '无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315012,
    msg: '无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315013,
    msg: '飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315014,
    msg: '当前任务类型不支持设置返航点.',
  },
  {
    code: 315015,
    msg: '返航点设置失败，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315016,
    msg: '飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315017,
    msg: '飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315018,
    msg: '任务失败，请等待两个机场都空闲后，再次下发任务重试.',
  },
  {
    code: 315019,
    msg: '设备部署位置不佳，无法执行蛙跳任务，请选择其它机场再试.',
  },
  {
    code: 315050,
    msg: '机场系统异常，请重启机场后重试.',
  },
  {
    code: 315051,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315052,
    msg: '机场位置未收敛，请等待一段时间后重试.',
  },
  {
    code: 315053,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315054,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315055,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315056,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315057,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315058,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315059,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315060,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315061,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315062,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315063,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315064,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 315065,
    msg: '任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后.',
  },
  {
    code: 316001,
    msg: '飞行器参数配置失败，请重启机场后重试',
  },
  {
    code: 316002,
    msg: '飞行器参数配置失败，请重启机场后重试',
  },
  {
    code: 316003,
    msg: '飞行器参数配置失败，请重启机场后重试',
  },
  {
    code: 316004,
    msg: '飞行器参数配置失败，请重启机场后重试',
  },
  {
    code: 316005,
    msg: '飞行器 RTK 收敛失败，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 316006,
    msg: '任务超时，飞行器已丢失或降落时机场未开启舱盖或展开推杆，飞行器无法降落回机场，请尽快至机场部署现场检查飞行器状况',
  },
  {
    code: 316007,
    msg: '飞行器初始化失败，请重启机场后重试',
  },
  {
    code: 316008,
    msg: '机场获取飞行器控制权失败，无法执行飞行任务，请确认遥控器未锁定控制权',
  },
  {
    code: 316009,
    msg: '飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）',
  },
  {
    code: 316010,
    msg: '机场未检测到飞行器，无法执行飞行任务，请检查舱内是否有飞行器，机场与飞行器是否已对频，或重启机场后重试',
  },
  {
    code: 316011,
    msg: '飞行器降落位置偏移过大，请检查飞行器是否需要现场摆正',
  },
  {
    code: 316012,
    msg: '飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 316013,
    msg: '飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 316014,
    msg: '飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 316015,
    msg: '飞行器 RTK 收敛位置距离机场过远，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 316016,
    msg: '飞行器降落至机场超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内',
  },
  {
    code: 316017,
    msg: '获取飞行器媒体数量超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内',
  },
  {
    code: 316018,
    msg: '飞行任务执行超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内',
  },
  {
    code: 316019,
    msg: '机场系统错误，无法执行飞行任务，请稍后重试',
  },
  {
    code: 316020,
    msg: '飞行器使用的 RTK 信号源错误，请稍后重试',
  },
  {
    code: 316021,
    msg: '飞行器 RTK 信号源检查超时，请稍后重试',
  },
  {
    code: 316022,
    msg: '飞行器无法执行返航指令，请检查飞行器是否已开机，机场与飞行器是否已断连，请确认无以上问题后重试',
  },
  {
    code: 316023,
    msg: '飞行器无法执行返航指令，飞行器已被 B 控接管，请在 B 控操控飞行器，或关闭 B 控后重试',
  },
  {
    code: 316024,
    msg: '飞行器执行返航指令失败，请检查飞行器是否已起飞，确认飞行器已起飞后请重试',
  },
  {
    code: 316025,
    msg: '飞行器参数配置失败，请稍后重试或重启机场后重试',
  },
  {
    code: 316026,
    msg: '机场急停按钮被按下，无法执行飞行任务，请释放急停按钮后重试',
  },
  {
    code: 316027,
    msg: '飞行器参数配置超时，请稍后重试或重启机场后重试',
  },
  {
    code: 316029,
    msg: '机场急停按钮被按下，飞行器将飞往备降点降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 316032,
    msg: '获取电池数据超时，请稍后重试或重启飞行器后重试',
  },
  {
    code: 316033,
    msg: '飞行器电池循环次数过高，为保证飞行安全，已自动终止任务，建议更换该电池',
  },
  {
    code: 316034,
    msg: '无法起飞，飞行器固件版本与机场固件版本不匹配，为保证飞行安全请升级固件后再试',
  },
  {
    code: 316035,
    msg: '进离场航线下发失败，请确保设备固件为最新版本后重新下发任务，如果持续报错，请联系大疆售后。',
  },
  {
    code: 316050,
    msg: '飞行器因电量过低在舱外降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 316051,
    msg: '飞行任务异常，飞行器在舱外降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 316052,
    msg: '飞行任务异常，飞行器将飞往备降点降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 316053,
    msg: '用户已操控飞行器降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 316100,
    msg: '获取相机概要信息失败，请重试',
  },
  {
    code: 316101,
    msg: '设置相机为单拍模式失败，请重试',
  },
  {
    code: 316102,
    msg: '关闭相机水印失败，请重试',
  },
  {
    code: 316103,
    msg: '设置测光模式到平均测光失败，请重试',
  },
  {
    code: 316104,
    msg: '切换镜头到广角镜头失败，请重试',
  },
  {
    code: 316105,
    msg: '设置相机存储照片失败，请重试',
  },
  {
    code: 316106,
    msg: '红外变焦倍数设置失败，请重试',
  },
  {
    code: 316107,
    msg: '照片尺寸设置4k失败，请重试',
  },
  {
    code: 316108,
    msg: '设置照片存储格式为jpeg格式失败，请重试',
  },
  {
    code: 316109,
    msg: '关闭相机畸变矫正失败，请重试',
  },
  {
    code: 316110,
    msg: '打开相机机械快门失败，请重试',
  },
  {
    code: 316111,
    msg: '设置对焦模式失败，请重试',
  },
  {
    code: 317001,
    msg: '获取飞行器媒体文件数量失败，请重启机场后重试',
  },
  {
    code: 317002,
    msg: '飞行器存储格式化失败，飞行器未开机、未连接或未检测到相机，请确认无以上问题后重试，或重启飞行器后重试',
  },
  {
    code: 317003,
    msg: '飞行器存储格式化失败，请重启飞行器后重试',
  },
  {
    code: 317004,
    msg: '机场媒体文件格式化失败，请稍后重试或重启机场后重试',
  },
  {
    code: 317005,
    msg: '飞行器结束录像失败，本次飞行任务的媒体文件可能无法上传',
  },
  {
    code: 317006,
    msg: '无法格式化，请等待当前飞行器媒体文件下载完成后再试',
  },
  {
    code: 317007,
    msg: '获取媒体文件数量失败，请稍后重试，如本架次任务有媒体文件且持续报错可联系大疆售后',
  },
  {
    code: 319001,
    msg: '机场作业中或设备异常反馈上传日志中，无法执行飞行任务，请等待当前飞行任务或操作执行完成后重试',
  },
  {
    code: 319002,
    msg: '机场系统运行异常，请重启机场后重试',
  },
  {
    code: 319003,
    msg: '机场系统运行异常，请重新下发任务',
  },
  {
    code: 319004,
    msg: '飞行任务执行超时，已自动终止本次飞行任务',
  },
  {
    code: 319005,
    msg: '云端与机场通信异常，无法执行飞行任务',
  },
  {
    code: 319006,
    msg: '取消飞行任务失败，飞行任务已经在执行中',
  },
  {
    code: 319007,
    msg: '修改飞行任务失败，飞行任务已经在执行中',
  },
  {
    code: 319008,
    msg: '机场时间与云端时间不同步，机场无法执行飞行任务',
  },
  {
    code: 319009,
    msg: '飞行任务下发失败，请稍后重试或重启机场后重试',
  },
  {
    code: 319010,
    msg: '机场固件版本过低，无法执行飞行任务，请升级机场固件为最新版本后重试',
  },
  {
    code: 319015,
    msg: '机场正在初始化中，无法执行飞行任务，请等待机场初始化完成后重试',
  },
  {
    code: 319016,
    msg: '机场正在执行其他飞行任务，无法执行本次飞行任务',
  },
  {
    code: 319017,
    msg: '机场正在处理上次飞行任务媒体文件，无法执行本次飞行任务，请稍后重试',
  },
  {
    code: 319018,
    msg: '机场正在自动导出日志中（设备异常反馈），无法执行飞行任务，请稍后重试',
  },
  {
    code: 319019,
    msg: '机场正在拉取日志中（设备异常反馈），无法执行飞行任务，请稍后重试',
  },
  {
    code: 319020,
    msg: '航线中断失败，请稍后重试',
  },
  {
    code: 319021,
    msg: '退出远程控制失败，请稍后重试',
  },
  {
    code: 319022,
    msg: '指点飞行失败，请稍后重试',
  },
  {
    code: 319023,
    msg: '指点飞行停止失败，请稍后重试',
  },
  {
    code: 319024,
    msg: '一键起飞失败，请稍后重试',
  },
  {
    code: 319025,
    msg: '机场未准备完成，无法执行云端下发的飞行任务，请稍后重试',
  },
  {
    code: 319026,
    msg: '飞行器电池电量低于用户设置的任务开始执行的电量，请等待充电完成后再执行飞行任务',
  },
  {
    code: 319027,
    msg: '机场或飞行器剩余存储容量过低，无法执行飞行任务，请等待媒体文件上传，机场和飞行器存储容量释放后再执行飞行任务',
  },
  {
    code: 319028,
    msg: '正在更新自定义飞行区',
  },
  {
    code: 319029,
    msg: '正在更新离线地图',
  },
  {
    code: 319030,
    msg: '操作失败，无飞行器控制权',
  },
  {
    code: 319031,
    msg: '控制权异常，请刷新重试',
  },
  {
    code: 319032,
    msg: '指点飞行失败，请稍后重试',
  },
  {
    code: 319033,
    msg: '虚拟程序操作失败，请稍后重试',
  },
  {
    code: 319034,
    msg: '虚拟摇杆操作失败，请稍后重试',
  },
  {
    code: 319035,
    msg: '急停失败，请稍后重试',
  },
  {
    code: 319036,
    msg: '设备远程调试中，请稍后重试',
  },
  {
    code: 319037,
    msg: '设备本地调试中，请稍后重试',
  },
  {
    code: 319038,
    msg: '设备正在升级，请稍后重试',
  },
  {
    code: 319042,
    msg: '航线恢复失败，请稍后重试',
  },
  {
    code: 319043,
    msg: '取消返航失败，请稍后重试',
  },
  {
    code: 319044,
    msg: '航线任务已结束，无法恢复',
  },
  {
    code: 319045,
    msg: '急停成功，请重新按键操作',
  },
  {
    code: 319046,
    msg: '无法暂停航线，飞行器尚未进入航线或已退出航线',
  },
  {
    code: 319999,
    msg: '机场系统运行异常，请重启机场后重试',
  },
  {
    code: 321000,
    msg: '航线执行异常，请稍后重试或重启机场后重试',
  },
  {
    code: 321004,
    msg: '航线文件解析失败，无法执行飞行任务，请检查航线文件',
  },
  {
    code: 321005,
    msg: '航线缺少新信息，机场无法执行飞行任务',
  },
  {
    code: 321257,
    msg: '飞行任务已在执行中，请勿重复执行',
  },
  {
    code: 321258,
    msg: '飞行任务无法终止，请检查飞行器状态',
  },
  {
    code: 321259,
    msg: '飞行任务未开始执行，无法终止飞行任务',
  },
  {
    code: 321260,
    msg: '飞行任务未开始执行，无法中断飞行任务',
  },
  {
    code: 321513,
    msg: '航线规划需已超过飞行器限高，机场无法执行飞行任务',
  },
  {
    code: 321514,
    msg: '任务失败，起点或终点位于限远区域的缓冲区内或超过了限远距离',
  },
  {
    code: 321515,
    msg: '航线穿过限飞区，机场无法执行飞行任务',
  },
  {
    code: 321516,
    msg: '飞行器飞行高度过低，飞行任务执行被终止',
  },
  {
    code: 321517,
    msg: '飞行器触发避障，飞行任务执行被终止。为保证飞行安全，请勿用当前航线执行断点续飞任务',
  },
  {
    code: 321519,
    msg: '飞行器接近限飞区或限远距离自动返航，无法完成航线飞行',
  },
  {
    code: 321523,
    msg: '飞行器起飞失败，请稍后重试，如果仍报错请联系大疆售后。',
  },
  {
    code: 321524,
    msg: '飞行器起飞前准备失败，可能是飞行器无法定位或档位错误导致，请检查飞行器状态',
  },
  {
    code: 321528,
    msg: '触碰自定义飞行区边界，航线任务已暂停',
  },
  {
    code: 321529,
    msg: '目标点位于禁飞区域或者障碍物内，无法到达，航线任务已暂停，请重新规划后再试',
  },
  {
    code: 321530,
    msg: '飞行器飞行航线过程中轨迹规划失败，航线任务已暂停',
  },
  {
    code: 321531,
    msg: '进离场航线执行失败，请联系大疆售后。',
  },
  {
    code: 321532,
    msg: '进离场航线执行失败，请联系大疆售后。',
  },
  {
    code: 321533,
    msg: '进离场航线执行失败，请联系大疆售后。',
  },
  {
    code: 321769,
    msg: '飞行器卫星定位信号差，无法执行飞行任务，请重点机场后重试',
  },
  {
    code: 321770,
    msg: '飞行器挡位错误，无法执行飞行任务，请重点机场后重试',
  },
  {
    code: 321771,
    msg: '飞行器返航点未设置，无法执行飞行任务，请重点机场后重试',
  },
  {
    code: 321772,
    msg: '飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）',
  },
  {
    code: 321773,
    msg: '飞行器执行飞行任务过程中低电量返航，无法完成航线飞行',
  },
  {
    code: 321775,
    msg: '飞行器航线飞行过程中失联，无法完成航线飞行',
  },
  {
    code: 321776,
    msg: '飞行器RTK收敛失败，无法执行飞行任务，请重点机场后重试',
  },
  {
    code: 321777,
    msg: '飞行器未停，无法开始执行飞行任务',
  },
  {
    code: 321778,
    msg: '用户使用B控操控飞行器起架，机场无法执行飞行任务',
  },
  {
    code: 321784,
    msg: '任务过程中遇到大风紧急返航',
  },
  {
    code: 322281,
    msg: '任务失败，机场执行飞行任务过程被手动打断或异常终止',
  },
  {
    code: 322282,
    msg: '机场执行飞行任务过程中被中断，飞行器被云端用户或遥控器接管',
  },
  {
    code: 322283,
    msg: '机场执行飞行任务过程中被用户触发返航，无法完成航线飞行',
  },
  {
    code: 322539,
    msg: '航线的断点信息错误，机场无法执行飞行任务',
  },
  {
    code: 322563,
    msg: '航线轨迹生成失败，请检查飞行器视觉镜头是否存在脏污或重启飞行器后再试，如果仍报错请联系大疆售后',
  },
  {
    code: 324012,
    msg: '日志压缩过程超时，所选日志过多，请减少选择的日志后重试',
  },
  {
    code: 324013,
    msg: '设备日志列表获取失败，请稍后重试',
  },
  {
    code: 324014,
    msg: '设备日志列表为空，请刷新页面或重启机场后重试',
  },
  {
    code: 324015,
    msg: '飞行器已关机或未连接，无法获取日志列表，请确认飞行器在舱内，通过远程调试将飞行器开机后重试',
  },
  {
    code: 324016,
    msg: '机场存储空间不足，日志压缩失败，请清理机场存储空间或稍后重试',
  },
  {
    code: 324017,
    msg: '日志压缩失败，无法获取所选飞行器日志，请刷新页面或重启机场后重试',
  },
  {
    code: 324018,
    msg: '日志文件拉取失败，导致本次设备异常反馈上传失败，请稍后重试或重启机场后重试',
  },
  {
    code: 324019,
    msg: '因机场网络异常，日志上传失败，请稍后重试。如果连续多次出现该问题，请联系代理商或大疆售后进行网络排障',
  },
  {
    code: 324021,
    msg: '因机场断电或重启导致日志导出中断，日志导出失败，请稍后重试',
  },
  {
    code: 324030,
    msg: '因机场网络异常、飞行器图像链路异常等原因，媒体文件暂时无法上传或文件已上传但云端读取失败',
  },
  {
    code: 325001,
    msg: '云端下发命令不符合格式要求，设备无法执行',
  },
  {
    code: 325003,
    msg: '指令响应失败，请重试',
  },
  {
    code: 325004,
    msg: '设备端命令请求已超时，请重试',
  },
  {
    code: 325005,
    msg: '当前机场无法响应任务，请稍后重试',
  },
  {
    code: 325006,
    msg: '当前机场启动检查中，请稍后重试',
  },
  {
    code: 325007,
    msg: '当前机场执行作业任务中，请稍后重试',
  },
  {
    code: 325008,
    msg: '当前机场处理作业任务结果中，请稍后重试',
  },
  {
    code: 325009,
    msg: '当前机场执行远程日志导出中，请稍后重试',
  },
  {
    code: 325010,
    msg: '当前机场更新自定义飞行区中，请稍后重试',
  },
  {
    code: 325011,
    msg: '当前机场更新离线地图中，请稍后重试',
  },
  {
    code: 325012,
    msg: '当前飞机未连接，请稍后重试',
  },
  {
    code: 326002,
    msg: '飞行器未安装 DJI Cellular 模块',
  },
  {
    code: 326003,
    msg: '飞行器 DJI Cellular 模块中未安装 SIM 卡',
  },
  {
    code: 326004,
    msg: '飞行器 DJI Cellular 模块需要强制升级，否则无法使用',
  },
  {
    code: 326005,
    msg: '操作失败，增强图传无法建立连接，请检查 4G 信号强度，或咨询运营商查询套餐流量和 APN 设置',
  },
  {
    code: 326006,
    msg: '增强图传开关切换失败，请稍后重试',
  },
  {
    code: 326008,
    msg: '机场未安装 DJI Cellular 模块',
  },
  {
    code: 326009,
    msg: '机场 DJI Cellular 模块中未安装 SIM 卡',
  },
  {
    code: 326010,
    msg: '机场 DJI Cellular 模块需要强制升级，否则无法使用',
  },
  {
    code: 326103,
    msg: '当前 eSIM 正在激活中，请稍后再试',
  },
  {
    code: 326104,
    msg: '当前 eSIM 正在切换运营商中，请稍后再试',
  },
  {
    code: 326105,
    msg: 'DJI 增强图传模块正在切换模式中，请稍后再试',
  },
  {
    code: 326106,
    msg: 'DJI 增强图传模块异常，请重启设备后再试，如果仍报错请联系大疆售后',
  },
  {
    code: 326107,
    msg: '请在设备管理 > 机场 > 设备运维中激活DJI增强图传模块的 eSIM 或插入 SIM 卡后再试',
  },
  {
    code: 327000,
    msg: '参数设置失败，请稍后重试',
  },
  {
    code: 327001,
    msg: '参数设置失败，请稍后重试',
  },
  {
    code: 327002,
    msg: '获取控制权失败，请稍后重试',
  },
  {
    code: 327003,
    msg: '获取控制权失败，请稍后重试',
  },
  {
    code: 327004,
    msg: '画面拖动失败，请重试',
  },
  {
    code: 327005,
    msg: '双击画面归中央败',
  },
  {
    code: 327006,
    msg: '拍照失败',
  },
  {
    code: 327007,
    msg: '开始录像失败',
  },
  {
    code: 327008,
    msg: '停止录像失败',
  },
  {
    code: 327009,
    msg: '切换相机模式失败',
  },
  {
    code: 327010,
    msg: 'ZOOM相机变焦失败',
  },
  {
    code: 327011,
    msg: 'IR相机变焦失败',
  },
  {
    code: 327012,
    msg: '获取控制权失败，请稍后重试',
  },
  {
    code: 327013,
    msg: '参数设置失败，请稍后重试',
  },
  {
    code: 327014,
    msg: '云台已达限位',
  },
  {
    code: 327015,
    msg: '直播启动失败，建议刷新直播或重新打开设备小窗',
  },
  {
    code: 327016,
    msg: '失联动作设置失败，请重试',
  },
  {
    code: 327017,
    msg: '指点飞行高度设置失败，请重试',
  },
  {
    code: 327018,
    msg: '指点飞行模式切换失败，请重试',
  },
  {
    code: 327019,
    msg: '当前状态无法看向标注点',
  },
  {
    code: 327020,
    msg: '全景拍照停止命令超时',
  },
  {
    code: 327050,
    msg: '当前设备状态不支持播放音频',
  },
  {
    code: 327051,
    msg: '下载音频文件失败',
  },
  {
    code: 327052,
    msg: '喊话器处理模式切换失败',
  },
  {
    code: 327053,
    msg: '上传音频文件失败',
  },
  {
    code: 327054,
    msg: '播放音频失败',
  },
  {
    code: 327055,
    msg: '设置工作模式失败',
  },
  {
    code: 327056,
    msg: '上传文本失败',
  },
  {
    code: 327057,
    msg: '停止播放失败',
  },
  {
    code: 327058,
    msg: '设置播放模式失败',
  },
  {
    code: 327059,
    msg: '设置音量失败',
  },
  {
    code: 327060,
    msg: '设置控件值失败',
  },
  {
    code: 319999,
    msg: 'Unknown error, e.g. restart after crash',
  },
  {
    code: 327061,
    msg: '发送文本值失败',
  },
  {
    code: 327062,
    msg: '切换系统语言失败',
  },
  {
    code: 327063,
    msg: '获取设备功能列表失败',
  },
  {
    code: 327064,
    msg: '获取设备配置文件失败',
  },
  {
    code: 327065,
    msg: '获取设备图片文件失败',
  },
  {
    code: 327066,
    msg: '设备文件压缩失败',
  },
  {
    code: 327067,
    msg: '设备文件上传失败',
  },
  {
    code: 327068,
    msg: '上传音频文件失败，md5校验失败',
  },
  {
    code: 327069,
    msg: '上传音频文件失败',
  },
  {
    code: 327070,
    msg: '上传音频文件失败，异常终止',
  },
  {
    code: 327071,
    msg: '上传TTS文本失败，md5校验失败',
  },
  {
    code: 327072,
    msg: '上传TTS文本失败',
  },
  {
    code: 327073,
    msg: '上传TTS文本失败，异常终止',
  },
  {
    code: 327074,
    msg: '喊话器重播失败',
  },
  {
    code: 327075,
    msg: '喊话器编码失败',
  },
  {
    code: 327201,
    msg: '全景拍照失败',
  },
  {
    code: 327202,
    msg: '全景拍摄终止',
  },
  {
    code: 327203,
    msg: '当前设备不支持全景拍照',
  },
  {
    code: 327204,
    msg: '系统繁忙，无法全景拍照',
  },
  {
    code: 327205,
    msg: '请求失败，无法全景拍照',
  },
  {
    code: 327206,
    msg: '飞机未起飞，无法开始全景拍摄',
  },
  {
    code: 327207,
    msg: '控制权获取失败，全景拍摄终止',
  },
  {
    code: 327208,
    msg: '未知相机错误，无法开始全景拍摄',
  },
  {
    code: 327209,
    msg: '相机超时，全景拍摄终止',
  },
  {
    code: 327210,
    msg: '无法全景拍照',
  },
  {
    code: 327211,
    msg: '存储空间不足，全景拍摄终止',
  },
  {
    code: 327212,
    msg: '飞机运动中，无法开始全景拍摄',
  },
  {
    code: 327213,
    msg: '云台运动中，无法开始全景拍摄',
  },
  {
    code: 327214,
    msg: '用户操作摇杆，全景拍摄终止',
  },
  {
    code: 327215,
    msg: '碰到限飞区，全景拍摄终止',
  },
  {
    code: 327216,
    msg: '触发距离限制，全景拍摄终止',
  },
  {
    code: 327217,
    msg: '云台受阻，全景拍摄终止',
  },
  {
    code: 327218,
    msg: '拍照失败，全景拍摄终止',
  },
  {
    code: 327219,
    msg: '全景图片拼接失败',
  },
  {
    code: 327220,
    msg: '加载标定参数失败，全景拍摄终止',
  },
  {
    code: 327221,
    msg: '调整相机参数失败，全景拍摄终止',
  },
  {
    code: 327500,
    msg: '飞行器镜头除雾失败，请稍后重试',
  },
  {
    code: 328051,
    msg: '飞机未完成实名登记，请连接遥控器，按照指引完成实名登记后飞行',
  },
  {
    code: 328052,
    msg: '飞机实名登记状态已注销，请连接遥控器，按照指引完成实名登记后飞行',
  },
  {
    code: 336000,
    msg: '指点飞行命令发送失败，请重试',
  },
  {
    code: 336001,
    msg: '飞行器数据异常，无法响应指令',
  },
  {
    code: 336002,
    msg: '飞行器GPS信号差',
  },
  {
    code: 336003,
    msg: '飞行器定位失效，无法响应指令',
  },
  {
    code: 336004,
    msg: '指点飞行自主规划失败',
  },
  {
    code: 336005,
    msg: '飞行器返航点未更新',
  },
  {
    code: 336006,
    msg: '飞行器已失联，已退出指点飞行',
  },
  {
    code: 336017,
    msg: '飞行器电量不足以完成当前任务',
  },
  {
    code: 336018,
    msg: '已切换飞行器规划模式',
  },
  {
    code: 336019,
    msg: '指点飞行因限高自动调整飞行高度',
  },
  {
    code: 336513,
    msg: '目标点在禁飞区内',
  },
  {
    code: 336514,
    msg: '目标点超出飞行器限远',
  },
  {
    code: 336515,
    msg: '目标点在禁飞区内',
  },
  {
    code: 336516,
    msg: '目标点超出飞行器限高',
  },
  {
    code: 336517,
    msg: '目标点超出飞行器限低',
  },
  {
    code: 337025,
    msg: '飞行器无法起飞',
  },
  {
    code: 337026,
    msg: '目标点异常，请重试',
  },
  {
    code: 337027,
    msg: '飞行器速度设置异常，请重试',
  },
  {
    code: 337028,
    msg: '飞行器版本异常，请检查飞行器版本',
  },
  {
    code: 337029,
    msg: '飞行器无法响应当前任务，请稍后重试',
  },
  {
    code: 337030,
    msg: '指令飞行安全离场高过低',
  },
  {
    code: 337537,
    msg: '已触碰禁飞区',
  },
  {
    code: 337538,
    msg: '已触碰飞行器限远',
  },
  {
    code: 337539,
    msg: '已触碰禁飞区',
  },
  {
    code: 337540,
    msg: '已触碰飞行器限高或限高区',
  },
  {
    code: 337541,
    msg: '已触碰飞行器限低',
  },
  {
    code: 337542,
    msg: '飞行器起飞失败，请重试',
  },
  {
    code: 337543,
    msg: '目标点可能在障碍物内，请检查周边环境',
  },
  {
    code: 337544,
    msg: '检测到障碍物，请检查周边环境',
  },
  {
    code: 337545,
    msg: '飞行器规划异常，请重试',
  },
  {
    code: 337546,
    msg: '已触碰自定义飞行区边界',
  },
  {
    code: 338001,
    msg: '飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试',
  },
  {
    code: 338002,
    msg: '飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试',
  },
  {
    code: 338003,
    msg: '飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试',
  },
  {
    code: 338004,
    msg: '飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试',
  },
  {
    code: 338005,
    msg: '起飞机场与降落机场部署距离超出限制，无法执行飞行任务，请选择两个部署距离不超过15km的机场执行任务',
  },
  {
    code: 338006,
    msg: '无法执行飞行任务，请检查降落机场是否已申请解禁证书、是否位于自定义禁飞区或是否位于自定义飞行区外',
  },
  {
    code: 338007,
    msg: '目标降落机场部署突破限高区间，无法执行任务，请申请解禁证书后再试',
  },
  {
    code: 338008,
    msg: '目标降落机场部署突破飞行器设置的限高，无法执行任务，请调整限高后重试',
  },
  {
    code: 338009,
    msg: '飞行器 GPS 定位信号差，无法执行任务，请重启飞行器后重试',
  },
  {
    code: 338010,
    msg: '飞行器定位失效，无法执行任务，请重启飞行器后重试',
  },
  {
    code: 338011,
    msg: '任务失败，目标机场处于地理鸟笼作业区域外，请重新规划任务后再试',
  },
  {
    code: 338017,
    msg: '飞行器数据更新失败，无法执行任务，请重启飞行器后重试',
  },
  {
    code: 338018,
    msg: '飞行器数据更新失败，无法执行任务，请重启飞行器后重试',
  },
  {
    code: 338019,
    msg: '飞行器到目标机场的返航路线正在规划中，无法执行任务，请重启飞行器后重试',
  },
  {
    code: 338020,
    msg: '飞行器无法根据规划的路程到达目标降落机场，无法执行任务，请重新选择降落机场后再试',
  },
  {
    code: 338021,
    msg: '飞行器当前电量不足以到达目标降落机场，无法执行任务，请给飞行器充电后重试',
  },
  {
    code: 338049,
    msg: '响应遥控器杆量，已退出指点飞行',
  },
  {
    code: 338050,
    msg: '响应终止指令，已退出指点飞行',
  },
  {
    code: 338051,
    msg: '飞行器低电量返航，已退出指点飞行',
  },
  {
    code: 338052,
    msg: '飞行器低电量降落，已退出指点飞行',
  },
  {
    code: 338053,
    msg: '附近有载人机，已退出指点飞行',
  },
  {
    code: 338054,
    msg: '响应其他高优先级任务，已退出指点飞行',
  },
  {
    code: 338255,
    msg: '飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试',
  },
  {
    code: 386535,
    msg: '航线执行异常，请稍后重试或重启机场后重试',
  },
  {
    code: 513002,
    msg: '直播失败，相机不存在或相机类型错误',
  },
  {
    code: 513003,
    msg: '相机已经在直播中，请勿重复开启直播',
  },
  {
    code: 513005,
    msg: '直播失败，直播参数（清晰度）设置错误',
  },
  {
    code: 513006,
    msg: '直播启动失败，请刷新重试',
  },
  {
    code: 513008,
    msg: '直播失败，设备端图传数据异常',
  },
  {
    code: 513010,
    msg: '直播失败，设备无法联网',
  },
  {
    code: 513011,
    msg: '操作失败，设备未开启直播',
  },
  {
    code: 513012,
    msg: '操作失败，设备已在直播中，不支持切换镜头',
  },
  {
    code: 513013,
    msg: '直播失败，直播使用的视频传输协议不支持',
  },
  {
    code: 513014,
    msg: '直播失败，直播参数错误或者不完整',
  },
  {
    code: 513015,
    msg: '直播异常，网络卡顿，请刷新后重试',
  },
  {
    code: 513016,
    msg: '直播异常，视频解码失败',
  },
  {
    code: 513017,
    msg: '直播已暂停，请等待当前飞行器媒体文件下载完成后再试',
  },
  {
    code: 513099,
    msg: '直播失败，请稍后重试',
  },
  {
    code: 514100,
    msg: '机场运行异常，请重启机场后重试',
  },
  {
    code: 514101,
    msg: '推杆闭合失败，请检查停机坪上是否存在异物，飞行器方向是否放反，或重启机场后重试',
  },
  {
    code: 514102,
    msg: '推杆展开失败，请检查停机坪上是否存在异物，或重启机场后重试',
  },
  {
    code: 514103,
    msg: '飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）',
  },
  {
    code: 514104,
    msg: '飞行器电池开始充电失败，请重启机场后重试',
  },
  {
    code: 514105,
    msg: '飞行器电池停止充电失败，请重启机场后重试',
  },
  {
    code: 514106,
    msg: '飞行器电源控制异常，请重启机场后重试',
  },
  {
    code: 514107,
    msg: '舱盖开启失败，请检查舱盖周围是否存在异物，或重启机场后重试',
  },
  {
    code: 514108,
    msg: '舱盖关闭失败，请检查舱盖周围是否存在异物，或重启机场后重试',
  },
  {
    code: 514109,
    msg: '飞行器开机失败，请检查飞行器是否在舱和飞机电量是否正常，或重启机场后重试',
  },
  {
    code: 514110,
    msg: '飞行器关机失败，请重启机场后重试',
  },
  {
    code: 514111,
    msg: '飞行器慢转收发控制异常，请重启机场后重试',
  },
  {
    code: 514112,
    msg: '飞行器慢转收发控制异常，请重启机场后重试',
  },
  {
    code: 514113,
    msg: '机场推杆与飞行器无法连接，请检查飞行器是否在舱内，推杆闭合时是否被卡住，充电连接器是否能完成损坏',
  },
  {
    code: 514114,
    msg: '获取飞行器电源状态失败，请重启机场后重试',
  },
  {
    code: 514116,
    msg: '无法执行当前操作，机场正在执行其他控制指令，请稍后重试',
  },
  {
    code: 514117,
    msg: '舱盖开启或关闭未到位，请重启机场后重试',
  },
  {
    code: 514118,
    msg: '推杆展开或闭合未到位，请重启机场后重试',
  },
  {
    code: 514120,
    msg: '机场与飞行器断连，请重启机场后重试或重新对频',
  },
  {
    code: 514121,
    msg: '机场急停按钮被按下，请释放急停按钮',
  },
  {
    code: 514122,
    msg: '获取飞行器充电状态失败，请重启机场后重试',
  },
  {
    code: 514123,
    msg: '飞行器电池电量过低无法开机',
  },
  {
    code: 514124,
    msg: '获取飞行器电池信息失败，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 514125,
    msg: '飞行器电池电量已接近满电状态，无法开始充电，请使用至95%以下再进行充电',
  },
  {
    code: 514134,
    msg: '雨量过大，机场无法执行飞行任务，请稍后重试',
  },
  {
    code: 514135,
    msg: '风速过大，机场无法执行飞行任务，请稍后重试',
  },
  {
    code: 514136,
    msg: '机场供电断开，机场无法执行飞行任务，请恢复机场供电后重试',
  },
  {
    code: 514137,
    msg: '环境温度低于-20℃ (-4°F)，机场无法执行飞行任务，请稍后重试',
  },
  {
    code: 514138,
    msg: '飞行器电池正在保养中，机场无法执行飞行任务，请等待保养结束后重试',
  },
  {
    code: 514139,
    msg: '飞行器电池无法执行保养指令，飞行器电池无需保养',
  },
  {
    code: 514140,
    msg: '飞行器电池无法执行保养指令，飞行器电池无需保养',
  },
  {
    code: 514141,
    msg: '机场系统运行异常，请重启机场后重试',
  },
  {
    code: 514142,
    msg: '飞行器起飞前，机场推杆与飞行器无法连接，请检查飞行器是否在舱内，推杆闭合时是否被卡住，充电连接器是否损坏',
  },
  {
    code: 514143,
    msg: '推杆未闭合或闭合不到位，请稍后重试或重启机场后重试',
  },
  {
    code: 514144,
    msg: '舱盖未关闭或关闭不到位，请稍后重试或重启机场后重试',
  },
  {
    code: 514145,
    msg: '机场处于现场调试中，无法执行当前操作或执行飞行任务，请断开遥控器和机场的数据线连接后重试',
  },
  {
    code: 514146,
    msg: '机场处于远程调试中，无法执行飞行任务，请退出远程调试后重试',
  },
  {
    code: 514147,
    msg: '设备升级中，无法进行远程调试或执行飞行任务，请等待升级完成后重试',
  },
  {
    code: 514148,
    msg: '机场已经在作业中，无法进行远程调试或再次执行飞行任务，请等待当前任务执行完成后重试',
  },
  {
    code: 514149,
    msg: '机场系统运行异常，无法执行飞行任务，请重启机场后重试',
  },
  {
    code: 514150,
    msg: '设备重启中，无法执行飞行任务，请等待重启完成后重试',
  },
  {
    code: 514151,
    msg: '设备升级中，无法执行设备重启指令，请等待升级完成后重试',
  },
  {
    code: 514153,
    msg: '机场已退出远程调试模式，无法执行当前操作',
  },
  {
    code: 514154,
    msg: '获取内循环出口温度失败，请稍后再试',
  },
  {
    code: 514156,
    msg: '飞机不在舱内，请立即检查飞行器是否已安全降落并将飞行器放回至机场',
  },
  {
    code: 514157,
    msg: '执行开机失败，无线充电线圈业务繁忙，请重启机场后再试',
  },
  {
    code: 514158,
    msg: '无法起飞，机场 RTK 业务异常，请重启机场后再试',
  },
  {
    code: 514159,
    msg: '任务失败，降落机场检测到飞行器，请确保降落机场没有飞行器后再试',
  },
  {
    code: 514162,
    msg: '飞行器和机场连接失败，请关闭机场舱盖或重启机场后再试',
  },
  {
    code: 514163,
    msg: '电池功能异常，请确保飞行器电池插入到位或重启飞行器后再试',
  },
  {
    code: 514164,
    msg: '设备重启失败，请稍后重试，如果仍报错请联系大疆售后',
  },
  {
    code: 514165,
    msg: '设备重启失败，请稍后重试，如果仍报错请联系大疆售后',
  },
  {
    code: 514170,
    msg: '机场系统初始化中，无法执行当前操作或指令，请等待机场系统初始化完成后重试',
  },
  {
    code: 514171,
    msg: '云端下发给机场的命令不符合格式要求，机场无法执行',
  },
  {
    code: 514172,
    msg: '飞行器无法关机，蓝牙连接状态为未连接，请尝试重启飞行器和机场，或去现场重新对频飞行器与机场后再试',
  },
  {
    code: 514173,
    msg: '由于天气原因（环境温度低于5度并且降雨大于等于中雨），可能导致桨叶结冰影响作业安全，暂无法执行任务',
  },
  {
    code: 514174,
    msg: '飞行器充电失败，机场舱盖开启或关闭未到位，请关闭舱盖后再试',
  },
  {
    code: 514180,
    msg: '停止空调制冷或停止空调制热失败，请稍后重试',
  },
  {
    code: 514181,
    msg: '开启空调制冷失败，请稍后重试',
  },
  {
    code: 514182,
    msg: '开启空调制热失败，请稍后重试',
  },
  {
    code: 514183,
    msg: '开启空调除湿失败，请稍后重试',
  },

  {
    code: 514184,
    msg: '当前温度低于 0 ℃（32°F），无法开启空调制冷',
  },
  {
    code: 514185,
    msg: '当前温度高于 45 ℃（115°F），无法开启空调制热',
  },
  {
    code: 514300,
    msg: '网关异常',
  },
  {
    code: 514301,
    msg: '请求超时，连接断开',
  },
  {
    code: 514302,
    msg: '网络证书异常，连接失败',
  },
  {
    code: 514303,
    msg: '网络异常，连接断开',
  },
  {
    code: 514304,
    msg: '请求被拒，连接失败',
  },
]
